import { useMutation } from "@tanstack/react-query";
import { Col, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import LoadingButton from "../../../components/Loading/LoadingButton";
import { postMethod } from "../../../function/helper";

export default function PayLinkCheckoutModalForm({ onSubmit, display }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();

  const { mutate, isPending } = useMutation({
    mutationKey: ["PayLinkCheckoutModalForm"],
    mutationFn: () =>
      postMethod("/totalpost/v1/payLink/sendMobileVerificationSMS", {
        mobile: getValues("mobile"),
      }).then(res => {
        if (res && res.status === 200) {
          onSubmit(getValues());
          return;
        }

        Swal.fire({
          icon: "error",
          text: res.message,
          confirmButtonColor: "red",
          confirmButtonText: "متوجه شدم",
        });
      }),
  });

  return (
    <form onSubmit={handleSubmit(mutate)} className={display}>
      <div className="d-flex flex-wrap row-gap-2">
        <Col xs={12} sm={6} className="px-1">
          <Form.Label>نام:</Form.Label>
          <Form.Control
            disabled={isPending}
            {...register("name", { required: "نام الزامی" })}
          />
          {errors.name && (
            <p className="fs-small text-danger mb-0">{errors.name.message}</p>
          )}
        </Col>

        <Col xs={12} sm={6} className="px-1">
          <Form.Label>نام خانوادگی:</Form.Label>
          <Form.Control
            disabled={isPending}
            {...register("lName", { required: "نام خانوادگی الزامی" })}
          />
          {errors.lName && (
            <p className="fs-small text-danger mb-0">{errors.lName.message}</p>
          )}
        </Col>

        <Col xs={12} sm={6} className="px-1">
          <Form.Label>شماره موبایل:</Form.Label>
          <Form.Control
            disabled={isPending}
            {...register("mobile", {
              required: "شماره موبایل الزامی",
              minLength: {
                value: 11,
                message: "شماره موبایل باید 11 رقم باشد",
              },
              maxLength: {
                value: 11,
                message: "شماره موبایل باید 11 رقم باشد",
              },
              validate: {
                format: v => {
                  if (v[0] !== "0" || v[1] !== "9") {
                    return "شماره موبایل باید با 09 شروع شود";
                  }

                  return true;
                },
              },
            })}
          />
          {errors.mobile && (
            <p className="fs-small text-danger mb-0">{errors.mobile.message}</p>
          )}
        </Col>

        <div className="w-100 mt-2">
          <LoadingButton
            center
            className="btn-purple"
            isLoading={isPending}
            title={isPending ? "در حال ارسال پیامک" : "تایید"}
            type="submit"
          />
        </div>
      </div>
    </form>
  );
}
